module.exports = __webpack_public_path__ + "img/floor2_11.217328d2.jpg";